// extracted by mini-css-extract-plugin
export default {"LoadingTitle":"iStyles_LoadingTitle__y0btS","LoadingSubtitle":"iStyles_LoadingSubtitle__z1Yj2"};